import {
  layoutMetaByCode,
  type LayoutCode,
  type LayoutMeta,
} from "./layoutMeta";

export const deMaasBeamInsetMm = layoutMetaByCode.debeursdemaas.beamInsetMm;
export const deMaasBeamInsetMeters = deMaasBeamInsetMm / 1000;

// Shared Staander side distances; each layout determines its beam anchor.
export const standingDoorBeamInsetMm = 300;
export const standingPanelBeamInsetMm = 200;
export const standingProfileWidthMm = 25;
export const standingDoorBeamInsetMeters = standingDoorBeamInsetMm / 1000;
export const standingPanelBeamInsetMeters = standingPanelBeamInsetMm / 1000;

export const isStaanderPanelDoor = (doorCode: string): boolean =>
  doorCode === "paneel" || doorCode === "paneelpaneel";

export const leafStyleLayoutBeamHeightOffsetByCode: Readonly<
  Partial<Record<string, number>>
> = Object.fromEntries(
  (Object.entries(layoutMetaByCode) as [LayoutCode, LayoutMeta][])
    .filter(([, meta]) => meta.beamInsetMm !== undefined)
    .map(([code, meta]) => [code, meta.beamInsetMm]),
);
